import { render, staticRenderFns } from "./Tbyd.vue?vue&type=template&id=00794316&scoped=true&"
var script = {}
import style0 from "./Tbyd.vue?vue&type=style&index=0&id=00794316&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00794316",
  null
  
)

export default component.exports